import React, { FC } from 'react'
import { Button, Row, Col } from 'antd'
import { IAdvanceSearchProp } from './Types'
import { SearchItem } from './item'
import { YHRightModal } from '../YHRightModal'
import './header.less'

export const AdvancedSearch: FC<IAdvanceSearchProp> = (props) => {
    const { handleReset = () => {}, handleSearch = () => {}, searchMoreFields, size, showAdvanced, setShowAdvanced } = props
    const onCancel = () => {
        setShowAdvanced(false)
    }
    const onOk = () => {
        handleSearch()
        setShowAdvanced(false)
    }
    const onReset = () => {
        handleReset()
    }

    return (
        <YHRightModal
            visible={showAdvanced}
            onOk={() => {}}
            onCancel={onCancel}
            title="高级搜索"
            width={360}
            bodyHeight={700}
            showFooter={true}
            footerButs={[
                <Button onClick={onReset}>恢复默认</Button>,
                <Button onClick={onCancel}>取消</Button>,
                <Button onClick={onOk} type="primary">
                    确定
                </Button>,
            ]}
        >
            <Row>
                {searchMoreFields?.map((el, index) => (
                    <>
                        <Col span={24}>
                            <span>{el.title}</span>
                        </Col>
                        <Col span={24} style={{ margin: '5px 0 15px 0' }}>
                            <SearchItem key={index} {...{ ...props, ...el, size, span: 24 }} />
                        </Col>
                    </>
                ))}
            </Row>
        </YHRightModal>
    )
}
